export default {
  text: 'Bekræft med {{provider}}',
  text_generic: 'Bekræft hos din betalingsudbyder',
  error: 'Vi kunne ikke åbne formularen fra {{provider}}. Prøv igen.',
  error_generic: 'Vi kunne ikke åbne betalingsudbyderens formular. Prøv igen.',
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
};
